export interface UpdateSystemBatchMenuRequest {
  id: string
  name: string
  menus: {
    key: string
    value: string
  }[]
  revision: number
}

export function UpdateSystemBatchMenuRequestToJSON(
  value: UpdateSystemBatchMenuRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    name: value.name !== '' ? value.name : undefined,
    menus:
      value.menus.length > 0
        ? value.menus.map(menu => {
            return {
              key: menu.key !== '' ? menu.key : '',
              value: menu.value !== '' ? menu.value : ''
            }
          })
        : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
